import {Fragment} from "react";
import Dialog from "./Dialog";
import FormattedButton from "../../FormattedButton";
import {useBoolState} from "@/hooks";
import {MessageDescriptor} from "react-intl";

type Props = {
    domainId: number;
    onSuccess: () => void;
    title: MessageDescriptor;
    successItemPath: string;
};

const CreateButton = (props: Props) => {
    const {domainId, onSuccess, title, successItemPath} = props;
    const [isOpen, setShowOn, setShowOff] = useBoolState();

    return (
        <Fragment>
            <FormattedButton onClick={setShowOn} message={title} />
            <Dialog
                title={title}
                domainId={domainId}
                successItemPath={successItemPath}
                onSuccess={() => {
                    onSuccess();
                }}
                isOpen={isOpen}
                close={setShowOff}
            />
        </Fragment>
    );
};

export default CreateButton;
